import { useQuery } from "@tanstack/react-query";
import axiosInstance from "../services/axiosInstance";
import { API_ENDPOINTS } from "../services/api/apiConfig";

export interface Appointment {
    id: number;
    status: "PENDING" | "APPROVED" | "REJECTED" | "CANCELLED";
    appointmentDateTime: string;
    doctor?: {
        id: number;
        firstName: string;
        lastName: string;
        specialty?: string;
    };
    patient?: {
        id: number;
        firstName: string;
        lastName: string;
    };
    reason?: string;
    reminderSent: boolean;
}

export const useAppointments = () => {
    return useQuery<Appointment[]>({
        queryKey: ['appointments', 'mine'],
        queryFn: async () => {
            const response = await axiosInstance.get(API_ENDPOINTS.APPOINTMENTS.MINE);
            return response.data;
        },
        refetchInterval: 60000, // Refresh every minute
    });
};
